import { Outlet, Link } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="flex min-h-screen">
      {/* Partie gauche : image pleine (1/3) */}
      <div
        className="hidden lg:block lg:w-1/3 bg-cover bg-top bg-no-repeat"
        style={{ backgroundImage: "url('/assets/images/psaumes&plantesv2.png')" }}
      />

      {/* Partie droite : formulaire (2/3) avec image de fond */}
      <div className="relative w-full lg:w-2/3 flex items-center justify-center min-h-screen">
        {/* Image de fond à droite */}
        <div
          className="absolute inset-0 bg-cover bg-top bg-no-repeat"
          style={{ backgroundImage: "url('/assets/images/blogimg/background 😃.jpeg')" }}
        />
        {/* Overlay très léger pour lisibilité */}
        <div className="absolute inset-0 bg-black/10" />

        {/* Contenu du formulaire */}
        <div className="relative z-10 w-full max-w-md mx+1 sm:mx-4 p-3 sm:p-6">
          {/* Logo centré et cliquable */}
          <div className="flex justify-center mb-6">
            <Link to="/">
              <img
                src="/assets/logo/logoPsaumesetplantes-removebg-preview.png"
                alt="Psaumes et Plantes"
                className="h-20 w-auto object-contain bg-white rounded-full transition-transform duration-200 hover:scale-105"
              />
            </Link>
          </div>
          {/* Carte du formulaire avec fond semi-transparent */}
          <div className="bg-black/80 backdrop-blur-sm rounded-2xl border border-white/20 p-2 md:p-6 shadow-2xl">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;